import React from "react";

const CategoryNode = ({node, selectedCategoryId, onSelect, depth}) => (
    <li>
        <button
            onClick={() => onSelect(node.itemCategoryId)}
            className={`block w-full text-left py-1 hover:text-pegasusPurple ${
                selectedCategoryId === node.itemCategoryId ? "text-pegasusPurple font-semibold" : "text-gray-700"
            }`}
            style={{paddingLeft : `${depth * 12}px`}}
        >
            {node.name}
        </button>
        {node.children.length > 0 && (
            <ul>
                {node.children.map((child) => (
                    <CategoryNode
                        key={child.itemCategoryId}
                        node={child}
                        selectedCategoryId={selectedCategoryId}
                        onSelect={onSelect}
                        depth={depth + 1}
                    />
                ))}
            </ul>
        )}
    </li>
);

const ItemCategoryNav = ({tree, selectedCategoryId, onSelect}) => (
    <ul className="space-y-1">
        <li>
            <button
                onClick={() => onSelect(null)}
                className={`block w-full text-left py-1 hover:text-pegasusPurple ${
                    !selectedCategoryId ? "text-pegasusPurple font-semibold" : "text-gray-700"
                }`}
            >
                Alle
            </button>
        </li>
        {tree.map((node) => (
            <CategoryNode
                key={node.itemCategoryId}
                node={node}
                selectedCategoryId={selectedCategoryId}
                onSelect={onSelect}
                depth={0}
            />
        ))}
    </ul>
);

export default ItemCategoryNav;
